// extracted by mini-css-extract-plugin
export default {"container":"Navbar_container__5EtZd","link":"Navbar_link__y5bt2"};